module.exports = __webpack_public_path__ + "static/media/logo-camaracaldeiraogrande.28384d8f.png";